
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/request-access/employee",
      function () {
        return require("private-next-pages/request-access/employee.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/request-access/employee"])
      });
    }
  